//dependencias
import React, { Component } from 'react';

//componentes
import AnioEscolarT from './anioEscolarT'

class Index extends Component {

    render(){
        return(
            <div>
                <AnioEscolarT />
            </div>
        );
    }

}
export default Index;